module.exports = __webpack_public_path__ + "img/Body E.691cc57a.png";